import React from 'react';
import './select_indicatif_modal.css'
import {IoMdContact} from 'react-icons/io'
import {RiCloseCircleLine} from 'react-icons/ri'
import {RiSearch2Line} from 'react-icons/ri'
import indicatifs, { join } from '../../utils/indicatifs';

const SelectIndicatifModal = ({showModal=false,setShowModal,onClose,selectedItem,setSelectedItem}) => {

    const [listIndicatifs,setListIndicatifs] = React.useState(indicatifs)

    const closeModal = () => {
        try{
            onClose()
            setShowModal(false)
        }catch{
            setShowModal(false)
        }
    }
    const selectItem =(item)=>{
        setSelectedItem(item)
        closeModal()
    }
    const filterList = (value)=>{
        setListIndicatifs(indicatifs.filter(item =>{
            let text = [item.label,"+" + item.value].join(' ')

            text = text.replace('é','e')
            text = text.replace('è','e')
            text = text.replace('ê','e')
            text = text.replace('ë','e')
            
            value = value.replace('é','e')
            value = value.replace('è','e')
            value = value.replace('ê','e')
            value = value.replace('ë','e')

            return text.toLocaleLowerCase().includes(value.toLocaleLowerCase())
        }))
    }

    if(showModal){
        return(
            <>
                <div className='select_indicatif_modal-overlay' onClick={closeModal}>
                </div>
                <div className="select_indicatif_modal">
                    <header className='row px-4 mb-2'>
                        <label className='row m-0 p-0 mt-3'>
                            <div className="col-10">
                                <input type="text" placeholder='Rechercher' onChange={e => filterList(e.target.value)}/>
                            </div>
                            <div className="col-2 text-end">
                                <RiSearch2Line size={20} color='rgba(0, 0, 0, 0.5)' />
                            </div>
                        </label>
                    </header>
                    <div className="row body">
                        <ul>
                            {
                                listIndicatifs.map(item => (
                                    <li onClick={()=>selectItem(item)}>
                                        <div className="row py-1">
                                            <div className="col-1">
                                                <img src={item.imgSrc} alt="" />
                                            </div>
                                            <div className="col-9">
                                                <div className="row">
                                                    <div className="col-3 text-start">
                                                        <span className='fw-bold'>+{item.value}</span>
                                                    </div>
                                                    <div className="col-9">
                                                        <span className={item === selectedItem && 'fw-bold'}>{item.label}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-2">
                                                <input type="radio" checked={item === selectedItem} />
                                            </div>
                                        </div>
                                        <hr className='p-0 m-0'/>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
            </>
        )
    }
};

export default SelectIndicatifModal;